"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.take = void 0;
var parser_1 = require("@masala/parser");
function take(items, separator) {
    if (items.length < 2) {
        throw 'take array must have at least two items';
    }
    var parser = parser_1.F.nop();
    if (!separator) {
    }
    items.forEach(function (item) {
        var next;
        if (typeof item === 'string') {
            next = takeString(item);
        }
        else if (Array.isArray(item)) {
            if (typeof item[0] === 'string') {
                next = takeArrayString(item[0], item[1]);
            }
            else {
                next = takeArrayParser(item[0], item[1]);
            }
        }
        else {
            next = item;
        }
        if (!separator) {
            separator = parser_1.C.charIn(' \r\n\f\t').drop();
        }
        parser = parser
            .then(separator.optrep().drop())
            .then(next)
            .then(separator.optrep().drop());
    });
    return parser;
}
exports.take = take;
function takeString(str) {
    return parser_1.C.string(str);
}
function takeArrayParser(parser, modifier) {
    if (modifier === '?') {
        return parser_1.F.try(parser).opt();
    }
    if (modifier === '*') {
        return parser_1.F.try(parser).optrep();
    }
    // +
    return parser.rep();
}
function takeArrayString(str, modifier) {
    if (modifier === '?') {
        return parser_1.F.try(parser_1.C.string(str)).opt();
    }
    if (modifier === '*') {
        return parser_1.F.try(parser_1.C.string(str)).optrep();
    }
    // +
    return parser_1.C.string(str).rep();
}
//# sourceMappingURL=take.js.map